import { createSelector } from 'reselect';

const userState = (state: any) => state.login;

export const selectUserId = createSelector([userState], (user) => {
  return user.id;
});
